/* global globalThis */
/**
 * Волна 37, участок «Найм» (T, F, E, A): боты «золото+» тратят запас монет на
 * оборону своих городов. Только у ботов золото+ (configs/botGoldPlus); каждая
 * подчасть — за своим гейтом A/B (isPreW37…Player в utils/bots/abTestGates).
 * Правила — в utils/bots/evaluation/w37Recruitment, применение — в
 * utils/bots/decisions/decideRecruitmentStep.
 *
 * Откуда. С 29.10 доход бонуса идет за каждый город (configs/playerBonus) —
 * город стал источником дохода бота. Харнесс на main 19795091 (480 партий,
 * w37_base_diag): у золото+ после стройки в R9 21–56 монет, в R13 91–181, а на
 * найм в R9–R12 уходит 1.5–2.5 монеты за раунд; потерь городов 1.4–1.8 за
 * партию, почти все — фронтирные. Главный тормоз — общий потолок армии в 4
 * отряда (decideRecruitmentStep): в R9–12 новый отряд не нанят из-за него в
 * 70–76% этапов найма при запасе 37–68 монет. Модель угрозы не учитывает найм
 * противника, который еще не ходил (на прод-реплеях — 4% захватов городов
 * золото+, фантом живого противника сбывается в 36%).
 */

// --- T: заслон города с угрозой захвата В ЭТОМ раунде

// Заслонов угрозы этого раунда сверх общего потолка армии (4 + точечные слоты
// фракций + слоты F). Каждый — под свой город (угроза этого раунда, держателя,
// который переживет урон, нет, своего отряда на казарме нет), поэтому потолок
// нужен лишь от разгона армии, которую потом нечем кормить (−2 в снабжении).
// Проба на 100 партиях (scratchpad w37/understand/u_3): городов с угрозой этого
// раунда по модели 0.70 / 0.88 на игрока за раунд (R9–10 / R11–12) плюс 0.19 /
// 0.31 только фантомом, без держателя из них 0.07 / 0.11 — двух слотов хватает
// на два одновременно угрожаемых пустых города
export const W37_THREAT_GUARD_EXTRA_SLOTS = 2;

// Монет, которые заслон оставляет на руках сверх своей цены и размера на эту
// фазу: как у держателя из накоплений волны 35 (W35_HOLDER_HIRE_COIN_MARGIN) —
// хватает на заслон d6 второму городу или на покупку размера держателю. Угрозы
// нескольким городам идут по ценности города (очки + доход), так что запас
// достается следующему по ценности
export const W37_THREAT_HIRE_COIN_MARGIN = 2;

// С какого запаса монет заслон ставится и против фантомного найма противника-
// БОТА (фантом живого — всегда). На 200 прод-реплеях (w37/understand/u_4)
// фантом бота сбывается в 4.5% (584 город-хода → 26 захватов), живого — в 36%
// (95 → 34): заслон против бота — страховка, которая окупается, только когда
// монеты почти ничего не стоят. Порог — профицит монет бота
// (BOT_COIN_SURPLUS_THRESHOLD = 20): с R9 у золото+ на старте войны 20–53
// монеты, к концу партии остается 68–129. В харнессе «прокси человека» — тоже
// бот: фантомы прокси считаются только с этого запаса
export const W37_THREAT_BOT_RECRUIT_MIN_COINS = 20;

// --- F: слоты армии сверх общего потолка — на оборону фронтира

// Порог запаса (свободных монет сверх накоплений на стройку), с которого бот
// получает слоты сверх потолка армии. Тот же профицит, что открывает элитные
// типы и докупку размера (BOT_COIN_SURPLUS_THRESHOLD = 20): в пробе (u_3) из
// этапов найма, где отряд не нанят только из-за потолка 4, запас ≥ 20 монет —
// в 144 из 159 (R5–8), 240 из 249 (R9–10) и 250 из 279 (R11–12)
export const W37_RICH_COINS = 20;

// Монет на каждый следующий слот сверх порога: первый слот — на пороге, далее
// +1 за каждые столько монет. Отряд d10 (5) и его размер в эту же фазу
// (2.3 квартала города × 2 монеты ≈ 5) — около 10; слоты считаются по текущим
// монетам, поэтому найм сам себя останавливает. Факторный A/B харнесса (отчет 35,
// по 8160 партий): при 15 монетах на слот и 3 слотах F дает +1.99 [−0.57; 4.43]
// очка, при 8 и 5 — +2.61 [0.31; 5.01] и +0.16 города в конце против +0.12;
// траты на армию R9+ почти те же (+4.76 против +4.54): упор не в числе слотов,
// а в фронтирных городах без своего отряда и свободных казармах
export const W37_RICH_COINS_PER_SLOT = 8;

// Слотов сверх потолка не больше: в R9–12 у золото+ 4.1–4.4 отряда при
// фермерском потолке 8.9–10.2 и 3.1–3.7 свободных казармах; неудержанных
// городов с открытым кольцом — 2.4 на игрока за раунд в R9–10 (u_3 §1, §3).
// 5 вместо первых 3 — по A/B отчета 35 (см. W37_RICH_COINS_PER_SLOT). 0 выключает
// F целиком: тип держателя F тоже требует ненулевых слотов. Цена F в партиях, где
// все боты золото+ одной версии (отчет 35, §5.4, парно на 8160 партиях): при 0 у
// ботов +3.3 очка и +7.2 монеты к концу, а у прокси человека винрейт тот же
// (+0.02 п.п.) и +1.2 очка — слоты в основном отбирают города у других ботов, и
// в «зеркале» это гонка вооружений
export const W37_RICH_MAX_EXTRA_SLOTS = 5;

// --- E: дорогие отряды при большом запасе

// Запас монет, с которого найм ставит первыми дорогие типы фракции (максимум
// размера от d10: d20, d12, d10) — тот же профицит BOT_COIN_SURPLUS_THRESHOLD,
// с которого прежнее правило (decideRecruitmentStep) ставит d20/d12 первыми, но
// только у фракций без своей ветки предпочтений (люди, орки, элементали). В
// пробе (u_3) наймы R9–12 при запасе 34–63 монеты: d10 265, d6 198, d8 88,
// d12 58, d20 23
export const W37_RICH_TYPE_COINS = 20;

// Сколько монет должно остаться после найма дорогого типа: размер ему в эту
// фазу (2.3 квартала × 2–3 монеты ≈ 5–7) и заслон d6 (2). Тип, после которого
// монет меньше, остается на своем месте в порядке фракции
export const W37_RICH_TYPE_RESERVE = 8;

// d20 запрещен с 10 раунда (не успевает вырасти). На казарме у рабочего лагеря
// (рост +4 вместо +2) — разрешен, пока до конца партии остается фаз снабжения
// не меньше этого числа (лимит партии − раунд): нанятый в R10 при лимите 13
// d20 к концу партии дорастает до 1 + ~3 (размер в эту фазу) + 4 × 3 = 16 —
// больше максимума d12 (12); в R11 — только до 12, как d12 за 8 монет
export const W37_D20_CAMP_MIN_SUPPLY_PHASES = 3;

// --- Калибровка харнесса: ручки через globalThis (в проде не заданы)

// Имена глобалов-переопределений ручек участка — для проверки SIM_W37_KNOBS в
// server/scripts/simulateBotBatch.js (имя вне списка — ошибка). Новая ручка — сюда же
export const W37_RECRUITMENT_KNOB_GLOBALS = [
  '__w37ThreatGuardExtraSlots',
  '__w37ThreatHireCoinMargin',
  '__w37ThreatBotRecruitMinCoins',
  '__w37RichCoins',
  '__w37RichCoinsPerSlot',
  '__w37RichMaxExtraSlots',
  '__w37RichTypeCoins',
  '__w37RichTypeReserve',
  '__w37D20CampMinSupplyPhases',
];

export const readW37RecruitmentKnob = (overrideName, value) => {
  const override = globalThis[overrideName];
  return typeof override === 'number' && Number.isFinite(override) ? override : value;
};

/**
 * Ручки участка на один вызов этапа найма. Оверрайды харнесса — глобалы из
 * W37_RECRUITMENT_KNOB_GLOBALS
 */
export const getW37RecruitmentKnobs = () => ({
  threatGuardExtraSlots: readW37RecruitmentKnob('__w37ThreatGuardExtraSlots', W37_THREAT_GUARD_EXTRA_SLOTS),
  threatHireCoinMargin: readW37RecruitmentKnob('__w37ThreatHireCoinMargin', W37_THREAT_HIRE_COIN_MARGIN),
  threatBotRecruitMinCoins: readW37RecruitmentKnob('__w37ThreatBotRecruitMinCoins', W37_THREAT_BOT_RECRUIT_MIN_COINS),
  richCoins: readW37RecruitmentKnob('__w37RichCoins', W37_RICH_COINS),
  richCoinsPerSlot: readW37RecruitmentKnob('__w37RichCoinsPerSlot', W37_RICH_COINS_PER_SLOT),
  richMaxExtraSlots: readW37RecruitmentKnob('__w37RichMaxExtraSlots', W37_RICH_MAX_EXTRA_SLOTS),
  richTypeCoins: readW37RecruitmentKnob('__w37RichTypeCoins', W37_RICH_TYPE_COINS),
  richTypeReserve: readW37RecruitmentKnob('__w37RichTypeReserve', W37_RICH_TYPE_RESERVE),
  d20CampMinSupplyPhases: readW37RecruitmentKnob('__w37D20CampMinSupplyPhases', W37_D20_CAMP_MIN_SUPPLY_PHASES),
});
